import { render } from "./ShowBoxesToClose.vue?vue&type=template&id=699d2c4b&scoped=true"
import script from "./ShowBoxesToClose.vue?vue&type=script&lang=js"
export * from "./ShowBoxesToClose.vue?vue&type=script&lang=js"

import "./ShowBoxesToClose.vue?vue&type=style&index=0&id=699d2c4b&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699d2c4b"]])

export default __exports__